import React from 'react';
import { Divider } from 'takeat-design-system-ui-kit';
import { Container, Header, SubHeader } from './styles';
import Product from './Product';

export default function Category({ category }) {
  return (
    <Container>
      <Header>
        <p>{category.name}</p>
      </Header>
      <SubHeader>
        <span style={{ width: '60%' }}>Item</span>
        <span style={{ width: '40%' }}>Código de barra EAN</span>
      </SubHeader>

      <Divider />
      {category?.products &&
        category?.products?.length > 0 &&
        category?.products?.map((product) => (
          <React.Fragment key={product.id}>
            <Product product={product} />

            <Divider />
          </React.Fragment>
        ))}
    </Container>
  );
}
